// Conversation's props builders: the family's, with its own charts model (the per-turn mode)
// and its own controls (the answer filter). Its cloud offers apply-to-all as a flat label on
// the cloud surface rather than as a controls field.

import { OE_PROPS_BUILDERS } from '@aytm/app/stats/page/question-views/oe/lib/props'
import { calcWcProps as calcOeWcProps } from '@aytm/app/stats/page/question-views/oe/lib/props/word-cloud'

import { calcChartsModelProps } from '@aytm/app/stats/page/question-views/cn/lib/props/charts-model'
import { calcControlsProps } from '@aytm/app/stats/page/question-views/cn/lib/props/controls'

export const CN_PROPS_BUILDERS = {
  ...OE_PROPS_BUILDERS,
  calcChartsModelProps,
  calcControlsProps,
  calcWcProps: inputs => ({ ...calcOeWcProps(inputs), applyToAllLabel: 'Apply to all' })
}
